import React from 'react';
import ImageGreenBlueGradient from "../../../images/green-blue-gredient-bg.png";

function BlockQuote(props) {
  const { quote, author, occupation, classes } = props.data;
  return (
    <div className={`blockquote-section section-gap ${classes}`} id={props.id ? props.id : ''}>
      <div className="container">
        <blockquote>
          {quote && <h6>
            {quote}
          </h6>}
          {/*<img className="gredient-img" src={ImageGreenBlueGradient} />*/}
          <p className="blockquote-text small"><span>{author}</span><span>{occupation}</span></p>
        </blockquote>
      </div>
    </div>
  );
}
export default BlockQuote;